import moment from 'moment';

import isMoment from 'utils/predicates/isMoment.util';

// NOTE: time zone dependent conversion
const fromDateToDayOfTheWeek = (date) => (isMoment(date) || Number.isSafeInteger(date) || typeof date === 'string' ? moment(date).day() : NaN);

export default fromDateToDayOfTheWeek;
